import React, { useEffect, useState } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import Select from "react-select";
import axios from "axios";
import { config_url } from "../../config";

const AssignTagsCategoriesModal = ({ blog_id, open, onClose }) => {
  const [tagsOptions, setTagsOptions] = useState([]);
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  useEffect(() => {
    if (blog_id) {
      // Fetch available tags and categories from backend
      const fetchOptions = async () => {
        try {
          const [tagsResponse, categoriesResponse] = await Promise.all([
            axios.get(`${config_url}/api/tags`), // Replace with your actual endpoint
            axios.get(`${config_url}/api/categories`), // Replace with your actual endpoint
          ]);

          setTagsOptions(
            tagsResponse.data.map((tag) => ({ value: tag.id, label: tag.name }))
          );
          setCategoriesOptions(
            categoriesResponse.data.map((cat) => ({
              value: cat.id,
              label: cat.name,
            }))
          );
        } catch (error) {
          console.error("Error fetching options:", error);
        }
      };

      fetchOptions();
    }
  }, [blog_id]);

  const handleSubmit = async () => {
    try {
      // Prepare payload
      const payload = {
        blog_id,
        tags: selectedTags.map((tag) => tag.value),
        categories: selectedCategories.map((cat) => cat.value),
      };

      // Send data to backend
      await axios.post(
        `${config_url}/api/blog-tags-categories/assign`,
        payload
      );

      alert("Tags and categories assigned successfully!");
      onClose(); // Close the modal after submission
    } catch (error) {
      console.error("Error assigning tags/categories:", error);
      alert("Failed to assign tags and categories.");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 800,
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Assign Tags and Categories
        </Typography>
        <div>
          <Typography variant="subtitle1" gutterBottom>
            Select Tags
          </Typography>
          <Select
            isMulti
            options={tagsOptions}
            value={selectedTags}
            onChange={setSelectedTags}
            placeholder="Select Tags"
          />
        </div>
        <div style={{ marginTop: "1rem" }}>
          <Typography variant="subtitle1" gutterBottom>
            Select Categories
          </Typography>
          <Select
            isMulti
            options={categoriesOptions}
            value={selectedCategories}
            onChange={setSelectedCategories}
            placeholder="Select Categories"
          />
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          sx={{ mt: 2 }}
        >
          Submit
        </Button>
      </Box>
    </Modal>
  );
};

export default AssignTagsCategoriesModal;
